<template>
  <div>
    <pillar-title-add></pillar-title-add>
  </div>
</template>

<script>
import PillarTitleAdd from "./PillarTitleAdd.vue";

export default {
  components: {
    PillarTitleAdd,
  },

  data() {
    return {};
  },
};
</script>
